import * as React from "react";
import * as showdown from "showdown";
import * as xss from "xss";
import style = require("./style.less");

interface MarkdownProps {
    markup: string;
}

const Markdown: React.StatelessComponent<MarkdownProps> = props => {
    const converter = new showdown.Converter({
        tables: true,
        strikethrough: true
    });

    const html = xss(converter.makeHtml(props.markup));
    return <div className={style.markdown} dangerouslySetInnerHTML={{__html: html}} />;
};

export default Markdown;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Markdown/Markdown.tsx